import React from 'react';
import PropTypes from 'prop-types';

import decorate from '_core/utils/decorate';
import * as component from '_core/utils/component';


const UPDATE_SIZE_TIMEOUT = 50;

const UPDATE_SIZE_LONG_TIMEOUT = 2000;

const UPDATE_SIZE_COUNT = 20;

const UPDATE_SIZE_EVENTS = 'resize mousemove mouseup keyup scroll'.split(' ');


export default decorate(class extends React.PureComponent {
  
  static decorateForwardRef = 'forwardRef';
  
  static decorateWith = {
  };
  
  static propTypes = {
    overflow: PropTypes.bool.isRequired,
    heightResponsiveness: PropTypes.bool.isRequired,
    alwaysVisible: PropTypes.bool.isRequired,
    onChange: PropTypes.func
  };
  
  static defaultProps = {
    overflow: false,
    heightResponsiveness: false,
    alwaysVisible: false
  };
  
  
  constructor(props) {
    super(props);
    
    this.state = { width: 0, height: 0 };
  }
  
  
  updateSizeListener = (event) => {
    if (this.updateSizeTimeout) {
      clearTimeout(this.updateSizeTimeout);
      
      this.updateSizeTimeout = null;
    }
    
    this.updateSize();
  }
  
  updateSizeStart = () => {
    this.updateSizeCount = UPDATE_SIZE_COUNT;
    
    if (!this.updateSizeTimeout)
      this.updateSizeTimeout = setTimeout(() => this.updateSize(), UPDATE_SIZE_TIMEOUT);
  };
  
  updateSize = () => {
    const container = this.updateSizeRefValue;
    
    if (!container)
      return;
    
    if (this.updateSizeCount > 0) {
      this.updateSizeCount--;
      
      this.updateSizeTimeout = setTimeout(() => this.updateSize(), UPDATE_SIZE_TIMEOUT);
    } else {
      this.updateSizeTimeout = setTimeout(() => this.updateSize(), UPDATE_SIZE_LONG_TIMEOUT);
    }
    
    const { width, height } = this.state;
    
    const newWidth = container.scrollWidth;
    const newHeight = container.scrollHeight;
    
    if (width !== newWidth || height !== newHeight) {
      const state = { width: newWidth, height: newHeight };
      
      this.setState(state);
      
      this.props?.onChange?.(state);
      
      this.updateSizeStart();
    }
  };
  
  updateSizeRef = (ref) => {
    this.updateSizeRefValue = ref;
    
    this.updateSize();
  };
  
  
  componentDidMount() {
    if (this.updateSizeTimeout)
      clearTimeout(this.updateSizeTimeout);
    
    this.updateSizeTimeout = null;
    
    UPDATE_SIZE_EVENTS.forEach((type) => window.addEventListener(type, this.updateSizeListener));
    
    this.updateSizeStart();
  }
  
  componentWillUnmount() {
    UPDATE_SIZE_EVENTS.forEach((type) => window.removeEventListener(type, this.updateSizeListener));
    
    if (this.updateSizeTimeout)
      clearTimeout(this.updateSizeTimeout);
    
    this.updateSizeTimeout = null;
  }
  
  render() {
    const {
      forwardRef,
      
      overflow,
      heightResponsiveness,
      alwaysVisible,
      
      className,
      style,
      
      containerClassName,
      containerStyle,
      
      children
    } = this.props;
    
    
    const rootProps = { ref: forwardRef, style: { ...style, position: 'relative', height: '100%' } };
    const containerProps = { style: { ...containerStyle, position: 'absolute', left: 0, top: 0, width: '100%' } };
    
    if (!overflow) {
      rootProps.style.overflow = 'hidden';
      containerProps.style.overflow = 'hidden';
    }
    
    if (className)
      rootProps.className = className;
    
    if (containerClassName)
      containerProps.className = containerClassName;
    
    if (heightResponsiveness) {
      rootProps.style.height = this.state.height;
      
      containerProps.ref = this.updateSizeRef;
    } else {
      rootProps.ref = component.ref(rootProps.ref, this.updateSizeRef);
      
      containerProps.style.height = '100%';
    }
    
    return (
      <div {...rootProps}>
        <div {...containerProps}>
          {heightResponsiveness || alwaysVisible || this.state.width > 0 && this.state.height > 0 ? children : null}
        </div>
      </div>
    );
  }
  
});
